import { ChevronDownIcon } from '../../../../../images/icons/ChevronDownIcon';
import { UserProfession } from '../../../../../enums/UserProfession';
import { AuthorizationCredentialDetail } from './AuthorizationCredentialDetail';
import { getStatusConfig } from './credentialV2Utils';

export const AuthorizationCredentialItem = ({
  authorization,
  isExpanded,
  handleToggle,
  allProfessions,
  credentialRules,
  onDelete,
  onSave,
  monitoredCredentials = [],
}) => {
  const professionName =
    UserProfession.getName(authorization?.profession)
    || authorization?.profession;

  const statusConfig = getStatusConfig(authorization?.status);

  return (
    <div
      style={{
        border: '1px solid #b7b7b7',
        borderTop: 0,
        paddingBottom: 0,
      }}
    >
      <div
        style={{
          padding: '16px 60px',
          borderBottom: isExpanded
            ? '1px solid #b7b7b7'
            : 0,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
        onClick={() => handleToggle(authorization?.id)}
      >
        <div style={{ flex: 1 }}>{professionName}</div>
        <div style={{ flex: 1 }}>
          {authorization?.state}
        </div>
        <div
          style={{
            flex: 1,
            color: statusConfig.color,
            fontWeight: 'bold'
          }}
        >
          {statusConfig.label}
        </div>
        <div
          style={{
            transform: isExpanded
              ? 'rotate(180deg)'
              : 'none',
            transition: 'transform 0.2s',
          }}
        >
          <ChevronDownIcon />
        </div>
      </div>

      {isExpanded && (
        <AuthorizationCredentialDetail
          authorization={authorization}
          allProfessions={allProfessions}
          credentialRules={credentialRules}
          onDelete={onDelete}
          onSave={onSave}
          monitoredCredentials={monitoredCredentials}
        />
      )}
    </div>
  );
};
